__turbopack_context__.v({
  "columnsLocation": "checkoutForms-module-scss-module__1B7urq__columnsLocation",
  "columnsNarrow": "checkoutForms-module-scss-module__1B7urq__columnsNarrow",
  "columnsWideNarrow": "checkoutForms-module-scss-module__1B7urq__columnsWideNarrow",
  "formInput": "checkoutForms-module-scss-module__1B7urq__formInput",
  "formText": "checkoutForms-module-scss-module__1B7urq__formText",
  "fullWidthField": "checkoutForms-module-scss-module__1B7urq__fullWidthField",
});
